<div>
  <div class="col-12 flex p-0">
    <div class="card p-4 m-0 shadow-none">
      <div class="card-body m-0" style="color: #0063b9">
        <h3 class="card-title" style="color: #0063b9">
          Comprar como invitado
        </h3>
        <form [formGroup]="guestForm">
          <div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <label style="color: #0063b9; font-weight: bold"
                  >{{ config.document.name }}*</label
                >

                @if(country=='pe'){

                <input
                  formControlName="rut"
                  type="text"
                  class="form-control"
                  [placeholder]="config.document.name + '*'"
                  (input)="noCharDni($event)"
                  autocomplete="off"
                  [maxlength]="8"
                />

                } @else{

                <input
                  formControlName="rut"
                  type="text"
                  class="form-control"
                  [placeholder]="config.document.name + '*'"
                  appLettersChar
                  autocomplete="off"
                  [maxlength]="documentIdLength"
                  (blur)="
                    guestForm.controls['rut'].setValue(
                      formatRut(guestForm.controls['rut'].value)
                    )
                  "
                  (focus)="
                    guestForm.controls['rut'].setValue(
                      cleanRut(guestForm.controls['rut'].value)
                    )
                  "
                />

                }

                <p
                  *ngIf="
                    guestForm.controls['rut'].invalid &&
                    guestForm.controls['rut'].touched
                  "
                  class="text-error-form-2"
                >
                  {{ config.document.name }} no válido, estimado usuario su
                  {{ config.document.name }} debe ingresarse sin '.', Ejemplo
                  de {{ config.document.name }} válido ({{
                    config.document.sample
                  }}).
                </p>
              </div>
            </div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <input
                  formControlName="nombre"
                  type="text"
                  class="form-control"
                  placeholder="Nombres*"
                  appLettersChar
                />
              </div>
            </div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <input
                  formControlName="apellido"
                  type="text"
                  class="form-control"
                  placeholder="Apellidos*"
                  appLettersChar
                />
              </div>
            </div>

            <div class="col-12 py-0">
              <div class="mb-3">
                <label style="color: #0063b9; font-weight: 100"
                  ><font style="margin-right: 10px">Código*</font> Teléfono
                  Fijo/Celular</label
                >
                <div class="input-group">
                  <div class="input-group-prepend" dropdown>
                    <button
                      id="button-basic"
                      dropdownToggle
                      type="button"
                      class="btn btn-outline-secondary dropdown-toggle"
                      aria-controls="dropdown-phone"
                    >
                      <i
                        [ngClass]="
                          selectedPhoneCode ==
                          this.config.phoneCodes.mobile.code
                            ? 'fa-solid fa-mobile-screen'
                            : 'fa-solid fa-phone'
                        "
                        style="margin-right: 1px"
                      ></i>
                      {{ selectedPhoneCode }}
                    </button>
                    <div
                      id="dropdown-phone"
                      *dropdownMenu
                      class="dropdown-menu"
                      role="menu"
                      aria-labelledby="button-basic"
                    >
                      <a
                        class="dropdown-item"
                        (click)="
                          selectPhoneCode(this.config.phoneCodes.mobile.code)
                        "
                        ><i
                          class="fa-solid fa-mobile-screen"
                          style="margin-right: 1px"
                        ></i
                        >{{ this.config.phoneCodes.mobile.code }}</a
                      >
                      <a
                        class="dropdown-item"
                        (click)="
                          selectPhoneCode(this.config.phoneCodes.landline.code)
                        "
                        ><i
                          class="fa-solid fa-phone"
                          style="margin-right: 1px"
                        ></i
                        >{{ this.config.phoneCodes.landline.code }}</a
                      >
                    </div>
                  </div>
                  <input
                    formControlName="telefono"
                    type="text"
                    class="form-control"
                    placeholder="Número de contacto*"
                    [maxLength]="phoneLength"
                    (input)="noCharPhone($event)"
                  />
                </div>

                <p
                  *ngIf="
                    guestForm.controls['telefono'].invalid &&
                    guestForm.controls['telefono'].touched
                  "
                  class="text-error-form-2"
                >
                  El número de contacto que ha ingresado no es válido.
                </p>
              </div>
            </div>
            <div class="col-12 py-0">
              <div class="mb-3">
                <autocomplete #emailValidate givenPlaceHolder="Email" />

                <!--
                <input
                  formControlName="email"
                  type="email"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$"
                  class="form-control"
                  placeholder="Email*"
                />

                <p
                  *ngIf="
                    formVisita.controls['email'].invalid &&
                    formVisita.controls['email'].touched
                  "
                  class="text-error-form-2"
                >
                  El Email ingresado no es válido
                </p>-->
              </div>
            </div>
          </div>
        </form>
      </div>
      <ng-container *ngIf="innerWidth >= 768">
        <div class="card-footer p-0">
          <div>
            <div class="col-12 py-0">
              <button
                type="button"
                [disabled]="!guestForm.valid || !emailValidate.isValidEmail"
                class="btn btn-secondary btn-lg w-100 text-center"
                (click)="registerUser(emailValidate)"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="innerWidth < 768">
        <div class="card-footer p-0">
          <div class="row">
            <div class="md:col-6">
              <button
                type="button"
                [disabled]="!guestForm.valid"
                style="margin-bottom: 20px"
                class="btn btn-secondary btn-lg w-100 text-center"
                (click)="registerUser(emailValidate)"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
